<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 15:17:10
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 15:27:14
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 14:24:52
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 14:47:28
-->
<!-- 查询线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
  
            },
            responseCode: {
                
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台月票类型名额扣减",
                t_url: this.commonUrls.test + "deductMonthTicketConfig",
                p_url: this.commonUrls.prod + "deductMonthTicketConfig",
                precondition: "无",
                fitSystem: "云停车场，传统停车场（线上开通的月票）",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'String', info4: '月票类型id' },
                        { info1: 'thirdpartyBillCode', info2: '是', info3: 'String', info4: '第三方唯一编号(长度不超过30)' },
                        { info1: 'thirdpartyIdentify', info2: '是', info3: 'String', info4: '授权商标识key' },
                        { info1: 'parkCodes', info2: '是', info3: 'JSONArray', info4: '车场编号列表' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'num', info2: '是', info3: 'Integer', info4: '开通数量' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '开通起始时间yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '开通截止时间yyyyMMddHHmmss' },
                        { info1: 'monthBillId', info2: '否', info3: 'Long', info4: '月票订单流水id' },


                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        // { info1: 'id', info2: '是', info3: 'Long', info4: '月票凭证id' },

					   ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/deductMonthTicketConfig.vue